import React from 'react';
import StatCard from './StatCard';

const StatisticsOverview = ({ statistics }) => {
  const { 
    totalClients, 
    totalServers, 
    remoteMaintenance 
  } = statistics;

  const avgServersPerClient = totalClients > 0 
    ? (totalServers / totalClients).toFixed(1) 
    : 0;

  const remoteMaintenancePercentage = totalClients > 0 
    ? Math.round((remoteMaintenance.enabled / totalClients) * 100) 
    : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard 
        title="Total Clients" 
        value={totalClients} 
        color="blue" 
      />
      
      <StatCard 
        title="Total Serveurs" 
        value={totalServers} 
        color="green" 
      />
      
      <StatCard 
        title="Télémaintenance" 
        value={`${remoteMaintenance.enabled} / ${totalClients}`}
        subtitle={`${remoteMaintenancePercentage}% activée`}
        color="purple" 
      />
      
      <StatCard 
        title="Moy. Serveurs/Client" 
        value={avgServersPerClient} 
        color="orange" 
      />
    </div>
  );
};

export default StatisticsOverview;